export default {
  LOGIN: 'login',
  LOGOUT: 'logout'
};
